import { InputV2, ButtonLoading, SimpleDialog, CustomCaptchaComponent } from 'components';
import React from 'react';

import { Grid, Button,useMediaQuery } from '@mui/material';
import { useStyles } from './style';

const BtnActionsRepeatDialog = ({
  isLoading,
  isAcceptDisabled,
  onAccept,
  onCancel,
}) => {
  return (
    <>
      <ButtonLoading
        type="submit"
        variant="contained"
        color="primary"
        loading={isLoading}
        name="بله"
        disabled={isAcceptDisabled}
        onClick={onAccept}
      />

      <Button disabled={isLoading} variant="contained" onClick={onCancel}>
        انصراف
      </Button>
    </>
  );
};

const RepeatitiveFileDg = (props) => {
  const classes = useStyles();
  const matches = useMediaQuery('(max-width:600px)');

  const {
    isLoadingAcceptReaptiveDg,
    enteredCaptchaRepeat,
    onRepeatGroupServiceCall,
    setIsOpenRepeativeDg,
    isOpenRepeativeDg,
    captchaDialogRef,
    setCaptchaIdDialogRepeat,
    setEnteredCaptchaRepeat,
  } = props;

  return (
    <SimpleDialog
      title="فایل تکراری"
      content="فایل انتخاب شده تکراری می باشد. آیا از ادامه عملیات مطمئن هستید؟"
      open={isOpenRepeativeDg}
      actions={
        <BtnActionsRepeatDialog
          isLoading={isLoadingAcceptReaptiveDg}
          isAcceptDisabled={!enteredCaptchaRepeat?.trim() || isLoadingAcceptReaptiveDg}
          onAccept={onRepeatGroupServiceCall}
          onCancel={() => setIsOpenRepeativeDg(false)}
        />
      }
    >
      <Grid container wrap={matches ? 'wrap' : 'nowrap'}>
      <InputV2
          label="کد امنیتی"
          forceValue={enteredCaptchaRepeat}
          onChangeValue={(e) => {
            const value = e.target.value;
            if (value.length > 5) {
              e.preventDefault();
              setEnteredCaptchaRepeat(value.slice(0, 5));
            } else {
              setEnteredCaptchaRepeat(value);
            }
          }}
          englishNumber
          rules={['isNumeric']}
          fullWidth
          dir="ltr"
          onKeyPress={(e) => {
            // مکانیزم کلیک بر روی دکمه اینتر نیز پیاده شد - تکس باکس کد امنیتی خالی نباشد و فکوس بر روی همین تکس باکس باشد
            if (e?.key == 'Enter' && enteredCaptchaRepeat && enteredCaptchaRepeat.trim()) {
              onRepeatGroupServiceCall();
            }
          }}
        />
        <CustomCaptchaComponent
          pageTitle="/TransferCredit - انتقال وجه - دیالوگ تکراری"
          ref={captchaDialogRef}
          setCaptchaId={setCaptchaIdDialogRepeat}
          setEnteredCaptcha={setEnteredCaptchaRepeat}
          sizeOptions={{ xs: '12', md: '10', lg: '10' }}
        />
      </Grid>
    </SimpleDialog>
  );
};

export default React.memo(RepeatitiveFileDg);
